import { Pipe, PipeTransform } from '@angular/core';
import { Variable } from '@mtna/pojo-consumer-ts';
import { RdsVariableDisplayType } from '@rds/shared-api';

@Pipe({
  name: 'rdsGetVariableCellValue',
})
export class RdsGetVariableCellValuePipe implements PipeTransform {
  transform(displayType: RdsVariableDisplayType, variable: Variable): string {
    if (!displayType || !variable) {
      return '';
    }

    switch (displayType) {
      case 'BOTH':
        return variable.label ? `${variable.id}: ${variable.label || ''}` : variable.id || '';
      case 'LABEL':
        return variable.label || variable.id || '';
      default:
        return variable.id || '';
    }
  }
}
